import { ProductTarifType, TARIF_TYPE } from 'shared/constants/business.constants';

type CatalogInputProduct = {
  id?: number;
  productId?: number;
  priceFamilyId?: number;
  quantity?: number;
  documentProductLineId?: number;
  type?: ProductTarifType;
};

type CatalogProductResult = {
  id?: number;
  type?: ProductTarifType;
};

type PriceFamilyIdentity = {
  id?: number;
  key?: string;
};

const isDirectCatalogResult = (priceFamily: PriceFamilyIdentity | undefined, result: CatalogProductResult): boolean => {
  if (priceFamily?.key === TARIF_TYPE.SEMIFORFAIT) {
    return result.type === TARIF_TYPE.SEMIFORFAIT_NON_TRANSFORM;
  }
  if (priceFamily?.key === TARIF_TYPE.FORFAIT) {
    return result.type === TARIF_TYPE.FORFAIT;
  }
  return result.type === TARIF_TYPE.GENERAL;
};

const getDocumentProductLineId = (product: CatalogInputProduct): number | undefined => {
  const lineId = product.documentProductLineId ?? product.id;
  return typeof lineId === 'number' && lineId > 0 ? lineId : undefined;
};

export const mapCatalogResultsToClientLines = ({
  inputProducts,
  productResults,
  priceFamilies,
}: {
  inputProducts: CatalogInputProduct[];
  productResults: CatalogProductResult[];
  priceFamilies: PriceFamilyIdentity[];
}): CatalogInputProduct[] => {
  const usedInputIndexes = new Set<number>();

  return productResults.map((result) => {
    const matchedInputIndex = inputProducts.findIndex((input, index) => {
      if (usedInputIndexes.has(index) || input.productId !== result.id) return false;

      const priceFamily = priceFamilies.find((family) => family.id === input.priceFamilyId);
      return isDirectCatalogResult(priceFamily, result);
    });

    if (matchedInputIndex < 0) {
      return {
        productId: result.id,
        quantity: 0,
        type: result.type,
        documentProductLineId: undefined,
      };
    }

    usedInputIndexes.add(matchedInputIndex);
    const matchedInput = inputProducts[matchedInputIndex];
    return {
      productId: result.id,
      priceFamilyId: matchedInput.priceFamilyId,
      quantity: matchedInput.quantity ?? 0,
      type: result.type,
      documentProductLineId: getDocumentProductLineId(matchedInput),
    };
  });
};
